// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header___1sya2","body":"body___1BSEd"};